module.exports = __webpack_public_path__ + "img/film_haut.013f5115.png";